import React, { useEffect, useState } from "react";
import "./preloader.css";
import { useLocation } from "react-router-dom";

export default function PreLoader(props) {
  const [height, setHeight] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!mounted) {
      setTimeout(() => {
        setHeight("0vh");
        setTimeout(() => {
          setMounted(true);
        }, 500);
      }, 200);
    }
  }, []);

  return (
    <div
      style={{ backgroundColor: "#212529", height: { height } }}
      className={`preloader flex-column justify-content-center align-items-center ${
        mounted ? "preloader-fade-out" : "preloader-fade-in"
      }`}
    >
      <img className={mounted ? "preloader-children-hide" : ""} src="/dist/img/logo.png" alt="Logo" />
      <i className={`mt-5 text-secondary fas fa-2x fa-sync fa-spin ${mounted ? "preloader-children-hide" : ""}`}></i>
    </div>
  );
}
